var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn-toggle',{class:['language-selector', `language-selector--${_vm.variant}`],attrs:{"value":_vm.$i18n.locale,"mandatory":"","dense":""},on:{"change":_vm.changeLocale}},_vm._l((_vm.languages),function(language){return _c('v-btn',{key:language.value,attrs:{"small":"","value":language.value}},[_vm._v(" "+_vm._s(language.text)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }